import { z } from 'zod'
import { emailField } from 'src/validation/fields'

export const resetPasswordSchema = z.object({
  email: emailField,
})
